
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"currentWidth","height":"currentHeight","viewBox":"0 0 36 36","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('circle',{attrs:{"cx":"18","cy":"18","r":"18","fill":"#F8F8FB"}}),_c('mask',{staticStyle:{"mask-type":"alpha"},attrs:{"id":"a","maskUnits":"userSpaceOnUse","x":"4","y":"8","width":"28","height":"28"}},[_c('g',{attrs:{"clip-path":"url(#clip0_4479_10541)"}},[_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M18 20.833a6.025 6.025 0 006.067-6.067A6.025 6.025 0 0018 8.7a6.025 6.025 0 00-6.067 6.066A6.025 6.025 0 0018 20.833zm0 3.15c-4.083 0-12.25 1.983-12.25 6.067V36h24.5v-5.95c0-4.084-8.167-6.067-12.25-6.067z","fill":"#A6ADB5"}})])]),_c('g',{attrs:{"mask":"url(#a)"}},[_c('circle',{attrs:{"cx":"18","cy":"18","r":"18","fill":"#A6ADB5"}})]),_c('defs',[_c('clipPath',{attrs:{"id":"clip0_4479_10541"}},[_c('path',{attrs:{"fill":"#fff","transform":"translate(4 8)","d":"M0 0h28v28H0z"}})])])])
          )
        }
      }
    